(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-all-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-all-reviews')) {
  customElements.define('st-all-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.starc-track');
      this.load();
    }
    async load() {
      try {
        let root = document.querySelector('.stgr');
        if (!root) {
          const response = await fetch(this.dataset.url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Reviews unavailable');
          root = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.stgr');
        }
        if (!root) throw new Error('Reviews unavailable');
        const groups = Array.from(root.querySelectorAll('.stgr-source-panel')).map(panel => ({
          cards: Array.from(panel.querySelectorAll('.stgr-card')),
          logo: panel.querySelector('.stgr-source-mark')
        }));
        if (groups.length !== 3) throw new Error('Review sources unavailable');
        const total = groups.reduce((sum, group) => sum + group.cards.length, 0);
        if (!total) throw new Error('Reviews unavailable');
        this.querySelector('.starc-total').textContent = this.dataset.total.replace('__COUNT__', total);
        this.querySelector('.starc-breakdown').textContent = this.dataset.breakdown.replace('__GOOGLE__', groups[0].cards.length).replace('__FACEBOOK__', groups[1].cards.length).replace('__SHOPIFY__', groups[2].cards.length);
        const fragment = document.createDocumentFragment();
        const longest = Math.max(...groups.map(group => group.cards.length));
        for (let index = 0; index < longest; index++) {
          for (const group of groups) {
            if (!group.cards[index]) continue;
            const card = group.cards[index].cloneNode(true);
            card.removeAttribute('data-shopify-editor-block');
            if (group.logo) {
              const logo = group.logo.cloneNode(true);
              logo.className = 'starc-logo';
              card.querySelector('.stgr-person').prepend(logo);
            }
            fragment.append(card);
          }
        }
        this.track.replaceChildren(fragment);
        this.querySelector('.starc-controls').hidden = false;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.step))));
        let timer;
        this.track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(() => this.position(), 100); }, { passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        });
        this.position();
      } catch {
        this.querySelector('.starc-total').textContent = this.querySelector('.starc-error').content.textContent;
      }
    }
    position() {
      const cards = Array.from(this.track.children);
      const left = this.track.getBoundingClientRect().left;
      let closest = 0;
      cards.forEach((card, index) => {
        if (Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[closest].getBoundingClientRect().left - left)) closest = index;
      });
      this.querySelector('.starc-position').textContent = this.dataset.position.replace('__CURRENT__', closest + 1).replace('__TOTAL__', cards.length);
    }
    move(step) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      let target = this.track.scrollLeft + step * (this.track.children[0].getBoundingClientRect().width + 20);
      if (step > 0 && this.track.scrollLeft >= max - 2) target = 0;
      if (step < 0 && this.track.scrollLeft <= 2) target = max;
      this.track.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-google-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-review-picker')) {
  customElements.define('st-review-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const buttons = [...this.querySelectorAll('[data-category]')];
      const items = [...this.querySelectorAll('[data-product-category]')];
      const search = this.querySelector('input[type="search"]');
      const status = this.querySelector('[role="status"]');
      const empty = this.querySelector('.stgr-picker-empty');
      const list = this.querySelector('.stgr-product-list');
      let category = 'all';
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const update = () => {
        const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
        let count = 0;
        items.forEach(item => {
          const matches = (category === 'all' || item.dataset.productCategory === category) && terms.every(term => normalize(item.dataset.search).includes(term));
          item.hidden = !matches;
          if (matches) count++;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === category)));
        status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(count));
        empty.hidden = count > 0;
        list.hidden = count === 0;
        list.scrollTop = 0;
      };
      buttons.forEach(button => {
        button.hidden = button.dataset.category !== 'all' && !items.some(item => item.dataset.productCategory === button.dataset.category);
        button.addEventListener('click', () => { category = button.dataset.category; update(); });
      });
      search.addEventListener('input', update);
      this.querySelector('.stgr-picker-reset').addEventListener('click', () => {
        category = 'all'; search.value = ''; update(); search.focus();
      });
      this.querySelector('.stgr-picker-tools').hidden = false;
      status.hidden = false;
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
